<!--惠企政策申报详情-->
<template>
  <div class="declare-container">
    <header-index/>
    <div class="declare-content">
      <div class="declare-breadcrumb">
        <span>您当前位置：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/projectCoach/index' }">政府政策</el-breadcrumb-item>
          <el-breadcrumb-item>详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="declare-content-info">
        <el-row :gutter="16">
          <el-col :span="18">
            <div class="declare-content-info-1">
              <p class="declare-title">{{subsidyPolicyInfo.title}}</p>
              <i :class="subsidyPolicyInfo.policyStatus=='已截止' ? 'status-stop' : 'status-afoot'">{{ subsidyPolicyInfo.policyStatus }}</i>
              <span class="gray-span">组织部门：</span><span class="block-span">{{ subsidyPolicyInfo.department }}</span>
              <span class="gray-span">申报时间：</span><span class="block-span">{{ subsidyPolicyInfo.timeFormat }}</span>
              <div style="padding-top: 20px">
                <el-button type="primary" @click="declare" v-if="subsidyPolicyInfo.policyStatus!='已截止'">立即申报</el-button>
              </div>
            </div>
            <div class="declare-content-info-2">
              <div class="el-content-info" v-html="subsidyPolicyInfo.text"></div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="declare-recommend-consultant">
              <div class="declare-round">
                <el-divider><span>推荐顾问</span></el-divider>
              </div>

            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <home_footer/>
    <Hang/>
    <el-dialog title="申报信息填写" :visible.sync="dialogVisible" class="dialog" width="35%">
      <el-form :model="declareForm" :rules="rules" ref="declareForm" class="declareForm" label-position="right" label-width="85px" :hide-required-asterisk="true">
        <el-form-item label="企业名称：" prop="company" hide-required-asterisk>
          <el-input v-model="declareForm.company"/>
        </el-form-item>
        <el-form-item label="联系人：" prop="name" hide-required-asterisk>
          <el-input v-model="declareForm.name"/>
        </el-form-item>
        <el-form-item label="联系电话：" prop="telephone" hide-required-asterisk>
          <el-input v-model="declareForm.telephone"/>
        </el-form-item>
        <el-form-item>
          <el-upload action="https://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg" :limit="9"
                     ref="upload"
                     list-type="text" :file-list="fileList" :on-exceed="handleExceed" :multiple="true"
                     :on-success="successUpload" :on-preview="handlePictureCardPreview"
                     :on-remove="handleRemove">
            <el-link type="primary" :underline="false" icon="el-icon-plus">上传附件</el-link>
          </el-upload>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button @click="dialogVisible=false">取消</el-button>
          <el-button type="primary" @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible2" title="文件在线预览" class="dialog" width="100%" top="0px">
      <file-pre ref="file_pre" :fileUrl="dialogImageUrl"/>
    </el-dialog>
  </div>
</template>

<script>
import HeaderIndex from "@/components/header/headerIndex";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import cityJson from "@/static/cityJson.json";
import filePre from "@/components/filePreview/filePre";
import {newFundingSubsidyPolicyInfo,submitFundingDeclarationApply} from '@/api/projectCoach'
export default {
  name: "declareRankDetails",
  components: {Hang, Home_footer, HeaderIndex,filePre},
  data() {
    return {
      cid:0,
      policyId:0,
      cityList:{},
      childNode:{},
      subsidyPolicyInfo:{},
      dialogVisible:false,
      declareForm:{
        company:'',
        telephone:'',
        name:'',
        fileList:[],
      },
      fileList:[],
      dialogVisible2:false,
      dialogImageUrl:'',
      rules:{
        company: [
          {required: true, message: '请输入企业名称', trigger: 'blur'}
        ],
        name:[
          {required: true, message: '请输入联系人', trigger: 'blur'}
        ],
        telephone:[
          {required: true, message: '请输入联系电话', trigger: 'blur'}
        ]
      }
    }
  },
  methods:{
    /*获取申报信息*/
    getDetails(){
      newFundingSubsidyPolicyInfo({id:this.policyId, cid:this.cid, uid:this.cid, request:'form'}).then(res=>{
        if (res.code==200){
          this.subsidyPolicyInfo=res.content.smesPolicyInfo;
        }
      })
    },
    /*立即申报*/
    declare(){
      this.dialogVisible=true;
    },
    /*上传图片成功处理*/
    successUpload(response, file, fileList) {
      this.declareForm.fileList=[];
      for (let list of fileList){
        this.declareForm.fileList.push(
            {name: list.name, size: list.size, suffix: list.raw.type, url: list.response.imgPath}
        )
      }
    },
    /*图片在线预览*/
    handlePictureCardPreview(file) {
      this.dialogImageUrl=file.response.imgPath;
      this.dialogVisible2=true;
    },
    /*检索上传数量，限制上传9张*/
    handleExceed(files, fileList) {
      this.$message.error(`已超过上传上限！`);
    },
    /*图片删除*/
    handleRemove(file, fileList) {
      for (let i in this.declareForm.fileList) {
        if (this.declareForm.fileList[i].url == file.response.imgPath) {
          this.declareForm.fileList.splice(i, 1)
        }
      }
    },
    /*提交申报信息*/
    onSubmit(){
      this.$refs.declareForm.validate((valid) => {
        if (valid) {
          let formData={
            cid: this.cid,
            companyName: this.declareForm.company,
            legalPerson: this.declareForm.name,
            list: this.declareForm.fileList,
            mobile: this.declareForm.telephone,
            pid: this.policyId,
            uid: this.cid
          };
          submitFundingDeclarationApply(formData).then(res=>{
            if (res.code==200){
              this.dialogVisible=false;
              this.$message.success(res.msg);
            }else{
              this.$message.error(res.msg);
            }
          })
        } else {
          return false;
        }
      });
    }
  },
  mounted() {
    this.getDetails();
  },
  beforeMount() {
    this.policyId=this.$route.query.policyId;
    this.cid=this.$route.query.cid;
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
    if (sessionStorage.getItem('childNode')) {
      this.childNode = JSON.parse(sessionStorage.getItem('childNode'));
    }
  }
}
</script>
<style scoped>
.declare-container >>> .declare-content .declare-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #5D5D5D;
}
.declare-container >>> .declare-content .declare-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.declare-container >>> .declare-content .declare-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.declare-container >>> .declare-content .declare-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.declare-container >>> .declare-content .declare-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #5D5D5D;
  font-family: 'SourceHanSansCN';
}
.declare-container >>> .declare-content .declare-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}
.declare-container >>> .declare-content .declare-breadcrumb .el-breadcrumb__inner a,
.declare-container >>> .declare-content .declare-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #333333;
}
.declare-container >>> .declare-content .declare-content-info .declare-content-info-1 .el-button--primary{
  color: #FFFFFF;
  background-color: #1637FF;
  border-color: #1637FF;
  font-size: 14px;
  font-family: 'SourceHanSansCN';
}
.dialog >>> .el-dialog__body {
  border-top: 1px solid #EEEEEE;
  padding: 20px 20px 10px;
  color: #333333;
  font-size: 14px;
  word-break: break-all;
}

.dialog >>> .el-dialog__title {
  line-height: 24px;
  font-size: 16px;
  color: #303133;
  font-weight: 100;
  font-family: 'SourceHanSansCN';
}

.dialog >>> .el-dialog__header {
  padding: 15px 20px 10px;
}
.dialog >>> .el-upload-list--picture-card .el-upload-list__item {
  width: 73px;
  height: 73px;
}
.dialog >>> .el-upload--picture-card {
  width: auto;
  height: auto;
  line-height: normal;
  border: none;
  padding: 5px 10px 5px 0px;
  color: #1637FF;
}
.dialog >>> .el-upload--picture-card i {
  font-size: 14px;
  color: #1637FF;
}
.dialog >>>.el-link [class*=el-icon-]+span {
  margin-left: 0px;
}
.dialog >>>.el-link.el-link--primary {
  color: #1637FF;
  font-size: 14px;
}
.dialog >>> .el-button--primary {
  color: #FFF;
  background-color: #1637FF;
  border-color: #1637FF;
}
.dialog >>> .el-dialog{
  margin: 0 auto 0px;
}
</style>
<style scoped lang="scss">
.declare-container {
  background: #F2F3FB;
  .declare-content {
    padding: 10px 18%;
    min-width: 76rem;
    background: #F2F3FB;
    .declare-breadcrumb {
      display: flex;
      justify-content: left;
      font-size: 14px;
      font-weight: 100;
      color: #333333;
      font-family: "SourceHanSansCN";
    }
    .declare-content-info{
      background: #F2F3FB;
      margin-top: 10px;
      .declare-content-info-1{
        background: #FFFFFF;
        padding: 20px;
        .declare-title{
          font-size: 24px;
          font-family: 'SourceHanSansCN';
          font-weight: 500;
          color: #333333;
          margin-block-end: 20px;
          margin-block-start: 0px;
        }
        .status-stop {
          font-style: normal;
          font-size: 12px;
          padding: 5px 10px;
          font-family: 'SourceHanSansCN';
          border-radius: 6px;
          color: #FE273B;
          background: #FFD2D4;
        }
        .status-afoot {
          background: #ECEFFE;
          color: #1637FF;
          font-style: normal;
          font-size: 12px;
          padding: 5px 10px;
        }
        .gray-span {
          color: #999999;
          font-size: 14px;
          font-family: 'SourceHanSansCN';
          padding-left: 20px;
        }
        .block-span {
          font-size: 14px;
          color: #333333;
          font-family: 'SourceHanSansCN';
        }
      }
      .declare-content-info-2{
        margin-top: 10px;
        background: #FFFFFF;
        padding: 20px;
      }
      .declare-recommend-consultant{
        padding: 10px;
        background: #FFFFFF;
        .declare-round{
          span{
            color: #333333;
            font-family: 'SourceHanSansCN';
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>